import { FormContainer } from '../../../../../../../../components-quick-win/form-container';
import SoleOwnerForm from '../../../../../../../../components-quick-win/sole-owner-form';

export const SoleOwnerInfo = () => {
  return (
    <FormContainer>
      <SoleOwnerForm />
    </FormContainer>
  );
};